export default __webpack_public_path__ + "static/media/04-fala.aae53766.jpg";